import { Box, Button, Container, Divider, Grid, IconButton, Paper } from "@mui/material";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Link, useNavigate } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";
import globalContext from '../context/context'
import axios from "axios";
import parse from 'html-react-parser';
import { CssTextField } from "../utils/CssTextField";
import { useTranslation } from "react-i18next";
import { isInCart } from "../utils/cart";

function ParkingPopup() {

    const { t } = useTranslation();

    const { contextData: { responseId, parking, currency, cart }, setParking, addToCart, setSnack } = useContext(globalContext);
    const navigate = useNavigate();

    const [details, setDetails] = useState(false);
    const [additionalData, setAdditionalData] = useState({
        plateNumber: ''
    });

    useEffect(() => {
        if (!parseInt(responseId, 10)) {
            navigate('/');
        }
    }, [])

    useEffect(() => {

        const getParkings = setTimeout(() => {
            if (!!parseInt(responseId, 10)) {
                axios.get(`/api/custom/parkings?searchId=${parseInt(responseId, 10)}&currency=${currency}`).then(r => {
                    setParking(r?.data);
                }).catch(e => {
                    setParking(null);
                })
            }
        }, 400);


        return () => {
            clearTimeout(getParkings);
        }

    }, [responseId])


    const setAdditionalDataChange = (e) => {
        setAdditionalData({ ...additionalData, [e.target.name]: e.target.value });
    }

    const handleAddToCart = (p) => {
        if (additionalData?.plateNumber) {
            addToCart({
                ...p,
                ...additionalData
            }, 'parkings');
        } else {
            setSnack({
                message: t('PopupPages.requiredPlateNumber'),
                severity: 'error',
                open: true
            })
        }
    }

    return (
        <>
            <Box className="orderElement" sx={{ bgcolor: 'rgba(0,0,0, .2)' }}>
                <Container sx={{ justifyContent: 'center', alignContent: 'center', alignItems: 'center', display: 'flex' }} >
                    <Paper className="orderElementPaper" sx={{ width: { xs: '95%', md: '60%' }, p: 3, bgcolor: '#fff' }}>
                        <Grid sx={{ justifyContent: 'space-between', alignItems: 'center' }} container>
                            <Grid item>
                                <Box sx={{ display: 'inline-block', color: '#d93e45', fontSize: '16px', fontWeight: 500 }}>
                                    <Box sx={{
                                        width: '40px',
                                        height: '40px',
                                        display: 'inline-block',
                                        mr: 2,
                                        verticalAlign: 'middle',
                                        backgroundImage: `url('/images/airport_parking.png')`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        backgroundRepeat: 'no-repeat',
                                    }}></Box>
                                    {t('PopupPages.parking')}
                                </Box>
                            </Grid>
                            <Grid item>
                            </Grid>
                        </Grid>
                        {parking && <>

                            {
                                parking?.length > 0 ?
                                    <>
                                        <Grid sx={{ py: 2 }} >
                                            <Divider />
                                        </Grid>
                                        <Grid sx={{ py: 2 }} >
                                            <CssTextField size="small"
                                                value={additionalData?.plateNumber}
                                                name="plateNumber"
                                                onChange={setAdditionalDataChange}
                                                sx={{ mt: 1 }} fullWidth variant="standard" label={t('PopupPages.plateNumber')} />

                                        </Grid>
                                    </>
                                    :
                                    <>
                                        <Grid sx={{ py: 2 }} >
                                            <Divider />
                                        </Grid>
                                        <Grid sx={{ py: 2 }} >
                                            Coming soon…
                                        </Grid>
                                    </>
                            }
                        </>}
                        {parking && parking?.map((p, pKey) => <React.Fragment key={pKey}>
                            <Grid sx={{ py: 2 }} >
                                <Divider />
                            </Grid>
                            <Grid>
                                <Box sx={{ fontSize: '14px', fontWeight: 500, pb: 1 }}>
                                    {p?.name} ({p?.airportCode})
                                </Box>
                                <Box sx={{ fontSize: '12px', fontWeight: 300 }}>
                                    {t("PopupPages.stars")} {p?.rating}
                                </Box>
                                <Box sx={{ fontSize: '12px', fontWeight: 300 }}>
                                    {details
                                        ? parse(p?.description)
                                        : <><strong style={{ cursor: 'pointer' }} onClick={() => setDetails(true)}>{t("PopupPages.clickHere")}</strong> {t("PopupPages.serviceDetails")}</>}

                                </Box>
                            </Grid>

                            <Grid>
                                <Box>
                                    <Grid sx={{ textAlign: 'center', py: 2 }} spacing={2} container>
                                        <Grid item>
                                            <Box sx={{ fontWeight: 300, fontSize: '10px', p: 1 }}>
                                                per vehicle
                                            </Box>
                                            <Box className="popupButton" sx={{ fontWeight: 700, fontSize: '16px', borderRadius: '20px', border: '1px solid #333', p: 1 }}>
                                                {p?.priceInCurrency} {p?.currency}
                                            </Box>
                                        </Grid>
                                        <Grid item>
                                             <Button
                                                 className="popupButton"
                                                 onClick={() => handleAddToCart(p)}
                                                 sx={{ fontWeight: 700, cursor: 'pointer', lineHeight: 1.25, color: '#d93e45', fontSize: '16px', borderRadius: '20px', border: isInCart(cart, p).isInCart ? '1px solid green' : '1px solid #d93e45', py: 1, px: 3, mt: 3.5 }}>
                                                 {isInCart(cart, p).isInCart ? t("PopupPages.remove") : t("PopupPages.cart")}
                                             </Button>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Grid>
                        </React.Fragment>)}
                    </Paper>
                </Container>

            </Box>

        </>
    );
}

export default ParkingPopup;
